module.exports = __webpack_public_path__ + "static/media/2.cd7b34b1.jpeg";